export default __webpack_public_path__ + "static/media/pchutney_powder.ef4dbbbc.png";